export default __webpack_public_path__ + "content/media/18.447f1ffa.jpg";